import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


import SearchFilterBar from '../../../components/ui/SearchFilterBar';

const AuditTrailTab = () => {
  const [searchValue, setSearchValue] = useState('');
  const [filters, setFilters] = useState([
    {
      key: 'action',
      label: 'Type d\'action',
      type: 'select',
      value: '',
      options: [
        { value: 'price_update', label: 'Modification prix' },
        { value: 'option_add', label: 'Ajout option' },
        { value: 'option_remove', label: 'Suppression option' },
        { value: 'setting_change', label: 'Changement paramètre' },
        { value: 'user_login', label: 'Connexion utilisateur' },
        { value: 'backup_create', label: 'Création sauvegarde' }
      ]
    },
    {
      key: 'user',
      label: 'Utilisateur',
      type: 'select',
      value: '',
      options: [
        { value: 'admin', label: 'Administrateur' },
        { value: 'manager', label: 'Gestionnaire' },
        { value: 'user', label: 'Utilisateur' }
      ]
    },
    {
      key: 'dateRange',
      label: 'Période',
      type: 'daterange',
      value: { from: '', to: '' }
    }
  ]);

  const [auditData] = useState([
    {
      id: 1,
      timestamp: new Date('2025-01-07T09:15:00'),
      user: 'Jean Dupont',
      userRole: 'Administrateur',
      action: 'price_update',
      actionLabel: 'Modification prix',
      description: 'Mise à jour tarif client professionnel - Style simple: 38,25€ → 39,50€',
      category: 'Tarification',
      ipAddress: '192.168.1.100',
      severity: 'medium'
    },
    {
      id: 2,
      timestamp: new Date('2025-01-07T08:45:00'),
      user: 'Marie Martin',
      userRole: 'Gestionnaire',
      action: 'option_add',
      actionLabel: 'Ajout option',
      description: 'Ajout nouvel électroménager: "Cave à vin" dans la catégorie électroménager',
      category: 'Options',
      ipAddress: '192.168.1.105',
      severity: 'low'
    },
    {
      id: 3,
      timestamp: new Date('2025-01-07T08:30:00'),
      user: 'Pierre Dubois',
      userRole: 'Administrateur',
      action: 'setting_change',
      actionLabel: 'Changement paramètre',
      description: 'Modification template email: Mise à jour objet par défaut',
      category: 'Système',
      ipAddress: '192.168.1.102',
      severity: 'medium'
    },
    {
      id: 4,
      timestamp: new Date('2025-01-06T17:20:00'),
      user: 'Sophie Leroy',
      userRole: 'Utilisateur',
      action: 'user_login',
      actionLabel: 'Connexion utilisateur',
      description: 'Connexion réussie à l\'interface d\'administration',
      category: 'Sécurité',
      ipAddress: '192.168.1.108',
      severity: 'low'
    },
    {
      id: 5,
      timestamp: new Date('2025-01-06T16:00:00'),
      user: 'Système',
      userRole: 'Système',
      action: 'backup_create',
      actionLabel: 'Création sauvegarde',
      description: 'Sauvegarde automatique quotidienne créée avec succès (2,3 MB)',
      category: 'Système',
      ipAddress: 'localhost',
      severity: 'low'
    },
    {
      id: 6,
      timestamp: new Date('2025-01-06T14:15:00'),
      user: 'Jean Dupont',
      userRole: 'Administrateur',
      action: 'price_update',
      actionLabel: 'Modification prix',
      description: 'Mise à jour tarif plan de travail Compact - Installation en L: 148,90€ → 152,00€',
      category: 'Tarification',
      ipAddress: '192.168.1.100',
      severity: 'medium'
    },
    {
      id: 7,
      timestamp: new Date('2025-01-06T11:30:00'),
      user: 'Marie Martin',
      userRole: 'Gestionnaire',
      action: 'option_remove',
      actionLabel: 'Suppression option',
      description: 'Suppression élément de finition: "Moulures anciennes" (non utilisé)',
      category: 'Options',
      ipAddress: '192.168.1.105',
      severity: 'high'
    },
    {
      id: 8,
      timestamp: new Date('2025-01-05T16:45:00'),
      user: 'Pierre Dubois',
      userRole: 'Administrateur',
      action: 'setting_change',
      actionLabel: 'Changement paramètre',
      description: 'Activation mode debug pour résolution problème export PDF',
      category: 'Système',
      ipAddress: '192.168.1.102',
      severity: 'high'
    }
  ]);

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'high':
        return 'text-error bg-error/10';
      case 'medium':
        return 'text-warning bg-warning/10';
      case 'low':
        return 'text-success bg-success/10';
      default:
        return 'text-text-secondary bg-muted';
    }
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'high':
        return 'AlertTriangle';
      case 'medium':
        return 'AlertCircle';
      case 'low':
        return 'Info';
      default:
        return 'Circle';
    }
  };

  const getActionIcon = (action) => {
    switch (action) {
      case 'price_update':
        return 'DollarSign';
      case 'option_add':
        return 'Plus';
      case 'option_remove':
        return 'Minus';
      case 'setting_change':
        return 'Settings';
      case 'user_login':
        return 'LogIn';
      case 'backup_create':
        return 'Database';
      default:
        return 'Activity';
    }
  };

  const formatTimestamp = (date) => {
    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })?.format(date);
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => prev?.map(filter =>
      filter?.key === key ? { ...filter, value } : filter
    ));
  };

  const handleClearFilters = () => {
    setFilters(prev => prev?.map(filter => ({
      ...filter,
      value: filter?.type === 'daterange' ? { from: '', to: '' } : ''
    })));
    setSearchValue('');
  };

  const handleExportAudit = () => {
    console.log('Exporting audit trail...');
    alert('Export du journal d\'audit en cours...');
  };

  return (
    <div className="space-y-6">
      {/* Search and Filters */}
      <SearchFilterBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        filters={filters}
        onFilterChange={handleFilterChange}
        onClearFilters={handleClearFilters}
        placeholder="Rechercher dans le journal d'audit..."
        showAdvancedFilters={true}
      />
      {/* Audit Trail */}
      <div className="bg-surface border border-border rounded-lg">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h3 className="text-lg font-semibold text-text-primary">Journal d'audit</h3>
            <p className="text-sm text-text-secondary mt-1">
              Historique des modifications et actions administratives
            </p>
          </div>
          <div className="flex items-center space-x-3">
            <Button variant="outline" iconName="Download" onClick={handleExportAudit}>
              Exporter
            </Button>
            <Button variant="outline" iconName="RefreshCw">
              Actualiser
            </Button>
          </div>
        </div>

        <div className="divide-y divide-border">
          {auditData?.map((entry) => (
            <div key={entry?.id} className="p-6 hover:bg-muted/30 transition-smooth">
              <div className="flex items-start justify-between">
                <div className="flex items-start space-x-4">
                  <div className={`p-2 rounded-lg ${getSeverityColor(entry?.severity)}`}>
                    <Icon name={getActionIcon(entry?.action)} size={16} />
                  </div>
                  
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center space-x-3 mb-2">
                      <span className="font-medium text-text-primary">
                        {entry?.actionLabel}
                      </span>
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${getSeverityColor(entry?.severity)}`}>
                        <Icon name={getSeverityIcon(entry?.severity)} size={12} className="inline mr-1" />
                        {entry?.severity === 'high' ? 'Critique' : 
                         entry?.severity === 'medium' ? 'Moyen' : 'Faible'}
                      </span>
                      <span className="px-2 py-1 bg-muted text-text-secondary text-xs rounded-full">
                        {entry?.category}
                      </span>
                    </div>
                    
                    <p className="text-sm text-text-primary mb-3">
                      {entry?.description}
                    </p>
                    
                    <div className="flex items-center space-x-6 text-xs text-text-secondary">
                      <div className="flex items-center space-x-1">
                        <Icon name="User" size={12} />
                        <span>{entry?.user} ({entry?.userRole})</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="Globe" size={12} />
                        <span>{entry?.ipAddress}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="Clock" size={12} />
                        <span>{formatTimestamp(entry?.timestamp)}</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <Button
                  variant="ghost"
                  size="sm"
                  iconName="MoreHorizontal"
                  className="text-text-secondary hover:text-text-primary"
                />
              </div>
            </div>
          ))}
        </div>

        {auditData?.length === 0 && (
          <div className="text-center py-12 text-text-secondary">
            <Icon name="Activity" size={48} className="mx-auto mb-4 opacity-50" />
            <p>Aucune entrée dans le journal d'audit</p>
          </div>
        )}

        {/* Pagination */}
        <div className="flex items-center justify-between p-6 border-t border-border">
          <div className="text-sm text-text-secondary">
            Affichage de 1 à 8 sur 24 entrées
          </div>
          <div className="flex items-center space-x-2">
            <Button variant="outline" size="sm" iconName="ChevronLeft" disabled>
              Précédent
            </Button>
            <Button variant="outline" size="sm">
              1
            </Button>
            <Button variant="ghost" size="sm">
              2
            </Button>
            <Button variant="ghost" size="sm">
              3
            </Button>
            <Button variant="outline" size="sm" iconName="ChevronRight">
              Suivant
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditTrailTab;